import { gsap } from '../vendor/gsap';
import { ScrollToPlugin } from '../vendor/gsap/ScrollToPlugin';
import { ScrollTrigger } from '../vendor/gsap/ScrollTrigger';
import transparentBeforeAnimation from '../lib/transparent-before-animation';
import addTranslateYAnimation from '../lib/add-translate-y-animation';
import addSimpleOpacityAnimation from '../lib/add-simple-opacity-animation';

gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(ScrollTrigger);

const sectionSelector = '.contacts-section';
const sectionCallBack = (sectionElement, query, queryAll) => {
    const content = query('.section-content');
    const columnsRow = queryAll('.row');
    const columns = queryAll('.col');
    const address = query('.contacts-section-info .address');
    const { templateUri } = document.body.dataset;
    const mapElement = query('.map');
    const timeline = gsap.timeline({
        scrollTrigger: {
            trigger: sectionElement,
            start: 'top 100%',
        },
    });
    const timelineColumns = gsap.timeline({
        scrollTrigger: {
            trigger: columnsRow,
            start: 'top 100%',
        },
    });
    transparentBeforeAnimation(content, timeline);
    addSimpleOpacityAnimation(timeline, mapElement);
    addTranslateYAnimation(timeline, address);
    addTranslateYAnimation(timelineColumns, columns);

    // eslint-disable-next-line func-names
    window.initMap = function () {
        const mapStyles = [
            {
                featureType: 'administrative',
                elementType: 'all',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        lightness: -100,
                    },
                    {
                        visibility: 'off',
                    },
                    {
                        saturation: '-77',
                    },
                ],
            },
            {
                featureType: 'administrative',
                elementType: 'labels.text.fill',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#848ea4',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'geometry',
                stylers: [
                    {
                        saturation: '-100',
                    },
                ],
            },
            {
                featureType: 'landscape',
                elementType: 'labels',
                stylers: [
                    {
                        saturation: '-80',
                    },
                    {
                        lightness: '-90',
                    },
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'poi',
                elementType: 'all',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        saturation: '-80',
                    },
                    {
                        lightness: '-70',
                    },
                    {
                        visibility: 'off',
                    },
                    {
                        gamma: '1',
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'geometry',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        saturation: '-85',
                    },
                    {
                        lightness: '60',
                    },
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'road',
                elementType: 'labels',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        saturation: '-70',
                    },
                    {
                        lightness: '50',
                    },
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#ffffff',
                    },
                ],
            },
            {
                featureType: 'road.arterial',
                elementType: 'geometry.stroke',
                stylers: [
                    {
                        visibility: 'on',
                    },
                    {
                        color: '#dcdcdc',
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'all',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        saturation: '0',
                    },
                    {
                        lightness: '-11',
                    },
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'road.local',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#f7f7f7',
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'geometry',
                stylers: [
                    {
                        visibility: 'simplified',
                    },
                    {
                        hue: '#0060ff',
                    },
                    {
                        lightness: '0',
                    },
                    {
                        saturation: '0',
                    },
                ],
            },
            {
                featureType: 'transit',
                elementType: 'labels',
                stylers: [
                    {
                        hue: '#0060ff',
                    },
                    {
                        lightness: -100,
                    },
                    {
                        visibility: 'off',
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'geometry',
                stylers: [
                    {
                        hue: '#0066ff',
                    },
                    {
                        saturation: '0',
                    },
                    {
                        lightness: 100,
                    },
                    {
                        visibility: 'on',
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'geometry.fill',
                stylers: [
                    {
                        color: '#c2d9e2',
                    },
                ],
            },
            {
                featureType: 'water',
                elementType: 'labels',
                stylers: [
                    {
                        hue: '#000000',
                    },
                    {
                        saturation: -100,
                    },
                    {
                        lightness: -100,
                    },
                    {
                        visibility: 'off',
                    },
                ],
            },
        ];
        // eslint-disable-next-line no-undef
        const styledMapType = new google.maps.StyledMapType(mapStyles, { name: 'GEM Realty Capital' });
        const iconUrl = `${templateUri}/dist/images/icon-map.svg`;
        const lat = Number.parseFloat(mapElement.dataset.latitude);
        const lng = Number.parseFloat(mapElement.dataset.longitude);
        const point = { lat, lng };
        // eslint-disable-next-line no-undef
        const map = new google.maps.Map(mapElement, {
            zoom: 15,
            center: point,
            mapTypeControl: false,
            streetViewControl: false,
        });

        map.mapTypes.set('styled_map', styledMapType);
        map.setMapTypeId('styled_map');

        const image = {
            url: iconUrl,
            // eslint-disable-next-line no-undef
            size: new google.maps.Size(32, 41),
            // eslint-disable-next-line no-undef
            scaledSize: new google.maps.Size(32, 41),
            // The origin for this image is (0, 0).
            // eslint-disable-next-line no-undef
            origin: new google.maps.Point(0, 0),
            // The anchor for this image is the base of the flagpole at (0, 32).
            // eslint-disable-next-line no-undef
            anchor: new google.maps.Point(16, 21),
        };

        // eslint-disable-next-line no-undef,no-unused-vars
        const marker = new google.maps.Marker({
            icon: image,
            position: point,
            url: mapElement.dataset.url,
            map,
        });

        // eslint-disable-next-line no-undef
        google.maps.event.addListener(marker, 'click', () => {
            window.open(marker.url, '_blank');
        });
    };

    const googleMapsAPI = document.createElement('script');
    googleMapsAPI.type = 'text/javascript';
    googleMapsAPI.defer = true;
    googleMapsAPI.src = `https://maps.googleapis.com/maps/api/js?key=${mapElement.dataset.api}&callback=initMap`;
    document.body.appendChild(googleMapsAPI);
};

export { sectionSelector, sectionCallBack };
